const ClickReferenciaBibliograficaObject = "Click Referencia Bibliografica Object";
const ClickReferenciaBibliograficaObjectAction = "Click_Referencia_Bibliografica_Object_Action";

export default ClickReferenciaBibliograficaObject;
export { ClickReferenciaBibliograficaObject, ClickReferenciaBibliograficaObjectAction };
